/* src/app/shared/components/language-dropdown/language-dropdown.component.scss */
:host {
  position: relative;
  display: flex;
}
.flag-holder {
  width: 100%;
  border: none;
  color: #282828;
  border-bottom: 1px solid #696969;
  font-family: "FSAlbertArabic-Regular";
  font-size: 14px;
  height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.flag-holder span {
  display: flex;
  line-height: 1;
  width: 100%;
  justify-content: space-between;
}
.flag-holder img {
  position: absolute;
  right: 10%;
  height: 12px;
  width: 16px;
  top: 10%;
}
.flag-list-container {
  height: 166px;
  overflow-y: scroll;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  width: 110%;
  color: #282828;
  font-family: "FSAlbertArabic-Regular";
  font-size: 14px;
  background: #FFFFFF;
  box-shadow: 0 2px 2px rgba(10, 16, 20, 0.24), 0 0 2px rgba(10, 16, 20, 0.12);
  margin-top: 2px;
  position: absolute;
  left: -5%;
  top: 100%;
  z-index: 1;
}
.flag-list-container ul {
  padding: 0px 4%;
}
.flag-list-container ul li {
  display: flex;
  padding: 10px 0px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
}
.flag-list-container ul li:not(:last-child) {
  border-bottom: 1px solid #696969;
}
.flag-list-container ul li img {
  position: absolute;
  height: 12px;
  width: 16px;
  right: 10%;
}
.flag-list-container ul li:hover,
.flag-list-container ul li.selected {
  background: #F3F2FA;
}
.fa-caret-down,
.fa-caret-up {
  font-size: 14px;
  margin: 0 5px;
  color: #10069F;
}
/*# sourceMappingURL=language-dropdown.component.css.map */
